import { Theme } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import PageHeader from '../components/PageHeader';

const ScrollablePage: FC<React.PropsWithChildren> = ({ children }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.scrollablePage}>
      <div className={classes.header}>
        <PageHeader />
      </div>
      <div className={classes.main}>{children}</div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  scrollablePage: {
    height: '100%',
    position: 'relative',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    position: 'sticky',
    top: 0,
    flex: '0 0 auto',
    marginInline: theme.spacing(2),
    borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
    overflow: 'hidden',
    boxShadow: theme.shadows[2],
    zIndex: theme.zIndex.appBar,
  },
  main: {
    padding: theme.spacing(2),
    flexGrow: 1,
  },
}));

export default ScrollablePage;
